export const nightingalePageConfig = {
  "pageShowType": "pc_inflextion",
  "title": "Date Comparison",
  "titleCN": "时间对比",
  "path": "/comparisonAnalysis/dateComparison",
  "defaultTab": "keyPerformance",
  "tabList": [
    {
      "id": "keyPerformance",
      "tabName": "Key Performance",
      "tabNameCN": "关键指标",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/dateComparison/keyPerformance",
      "path": "/comparisonAnalysis/dateComparison/keyPerformance",
      "tabIcon": "",
      "logConfig": {
        "pageId": "203601",
        "pageName": "nightingaleDateComparisonkeyPerformance",
        "extInfo": "nightingaleDateComparisonkeyPerformance",
        "pagePath": "/comparisonAnalysis/dateComparison/keyPerformance"
      },
      "data": {
        "dataFrame": "pc_inflextion",
        "metrics": {
          "value": "dau",
          "metric_key": "active_users",
          "enName": "DAU",
          "cnName": "日活跃",
          "rainbowKey": "",
          "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
          "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
          "type": "int",
          "decimal": 0
        },
        "haveChurnLevel": false
      },
      "children": [
        {
          "name": "SegmentMoreCo",
          "className": "",
          "style": {
            "marginTop": "0px",
            "marginRight": "5px"
          },
          "type": "view",
          "props": {
            "config": {
              "componentSegment": {
                "Day": [
                  {
                    "value": "dau",
                    "metric_key": "active_users",
                    "enName": "DAU",
                    "cnName": "日活跃",
                    "rainbowKey": "",
                    "explainEn": "Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).",
                    "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "new",
                    "metric_key": "new_users",
                    "enName": "New",
                    "cnName": "新进用户",
                    "rainbowKey": "",
                    "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).",
                    "explainCn": "统计周期内新注册用户数(vopenid数去重)。",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "tru",
                    "metric_key": "total_users",
                    "enName": "TNU",
                    "cnName": "总注册用户数",
                    "rainbowKey": "",
                    "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                    "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "revenue",
                    "metric_key": "pay_amount",
                    "enName": "Revenue($)",
                    "cnName": "付费金额($)",
                    "rainbowKey": "",
                    "explainEn": "Total player payment amount in statistical period, which does not include refund data, used the exchange rate from last-month settlement. This amount will deviate from the actual settlement of accounts this month for about 5% to 30%, due to the difference in exchange rate, timezone, billing amount. Please take note.",
                    "explainCn": "统计周期内玩家的付费金额总额，注：此收入不含退款数据，且采用汇率为财务上一月结算汇率，与实际财务结算会在汇率、时区、计费金额等情况上会有误差，误差在5%-30%不等，请知悉。",
                    "type": "decimals",
                    "decimal": 2
                  },
                  {
                    "value": "pcu",
                    "metric_key": "pcu",
                    "enName": "PCU",
                    "cnName": "最高同时在线",
                    "rainbowKey": "",
                    "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                    "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "acu",
                    "metric_key": "acu",
                    "enName": "ACU",
                    "cnName": "平均同时在线",
                    "rainbowKey": "",
                    "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                    "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "aot_hour",
                    "metric_key": "aot_hour",
                    "enName": "Avg.Playtime(h)",
                    "cnName": "平均在线时长(小时)",
                    "rainbowKey": "Pc Avg.Playtime(h)",
                    "explainEn": "",
                    "explainCn": "",
                    "type": "decimals",
                    "decimal": 2
                  },
                  {
                    "value": "d1",
                    "metric_key": "d1",
                    "enName": "D1",
                    "cnName": "次留",
                    "rainbowKey": "",
                    "explainEn": "The retention rate of new register users on day 1. Number of retained users on day N from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                    "explainCn": "次留=xx注册日期第1天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "d237",
                    "metric_key": "d2",
                    "enName": "D2",
                    "cnName": "2留",
                    "rainbowKey": "",
                    "explainEn": "The retention rate of new register users on day 2. Registration date is day 0",
                    "explainCn": "2留=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "d3",
                    "metric_key": "d3",
                    "enName": "D3",
                    "cnName": "3留",
                    "rainbowKey": "",
                    "explainEn": "The retention rate of new register users on day 3. Registration date is day 0",
                    "explainCn": "3留=xx注册日期第3天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "d4",
                    "metric_key": "d4",
                    "enName": "D4",
                    "cnName": "4留",
                    "rainbowKey": "",
                    "explainEn": "The retention rate of new register users on day 4. Registration date is day 0",
                    "explainCn": "4留=xx注册日期第4天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "d5",
                    "metric_key": "d5",
                    "enName": "D5",
                    "cnName": "5留",
                    "rainbowKey": "",
                    "explainEn": "The retention rate of new register users on day 5. Registration date is day 0",
                    "explainCn": "5留=xx注册日期第5天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "d6",
                    "metric_key": "d6",
                    "enName": "D6",
                    "cnName": "6留",
                    "rainbowKey": "",
                    "explainEn": "The retention rate of new register users on day 6. Registration date is day 0",
                    "explainCn": "6留=xx注册日期第6天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "d7",
                    "metric_key": "d7",
                    "enName": "D7",
                    "cnName": "7留",
                    "rainbowKey": "",
                    "explainEn": "The retention rate of new register users on day 7. Registration date is day 0",
                    "explainCn": "7留=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "mtx_payers",
                    "metric_key": "mtx_payers",
                    "enName": "In-Game Payer",
                    "cnName": "内购付费人数",
                    "rainbowKey": "",
                    "explainEn": "Total number of users who have in-game payment behaviors in the statistical period (deduplicated)",
                    "explainCn": "统计期间内有游戏内付费行为的用户总数（去重）",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "mtx_payer_rate",
                    "metric_key": "mtx_payer_rate",
                    "enName": "In-Game Payer%",
                    "cnName": "内购付费渗透率",
                    "rainbowKey": "",
                    "explainEn": "Number of In-Game paying users/Number of active users during the statistical period",
                    "explainCn": "内购付费人数/统计周期内的活跃人数",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "mtx_arpu",
                    "metric_key": "mtx_arpu",
                    "enName": "In-Game ARPU",
                    "cnName": "内购ARPU",
                    "rainbowKey": "",
                    "explainEn": "In-Game Revenue/Number of active users during the statistical period",
                    "explainCn": "内购收入/统计周期内的活跃人数",
                    "type": "decimals",
                    "decimal": 2
                  },
                  {
                    "value": "mtx_arppu",
                    "metric_key": "mtx_arppu",
                    "enName": "In-Game ARPPU",
                    "cnName": "内购付费ARPPU",
                    "rainbowKey": "",
                    "explainEn": "In-Game Revenue/Number of In-Game pay users during the statistical period",
                    "explainCn": "内购收入/统计期间内的内购付费人数",
                    "type": "decimals",
                    "decimal": 2
                  },
                  {
                    "value": "newPayer",
                    "metric_key": "new_paid_users",
                    "enName": "First-time Payer",
                    "cnName": "首次付费用户",
                    "rainbowKey": "",
                    "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                    "explainCn": "在游戏内首次发生付费行为的玩家数",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "newRevenue",
                    "metric_key": "new_pay_amount",
                    "enName": "Revenue(first-time payer)",
                    "cnName": "首次付费用户金额",
                    "rainbowKey": "",
                    "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                    "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                    "type": "decimals",
                    "decimal": 2
                  },
                  {
                    "value": "newArppu",
                    "metric_key": "new_arppu",
                    "enName": "First-time Payer ARPPU($)",
                    "cnName": "首次付费用户ARPPU($)",
                    "rainbowKey": "",
                    "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                    "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数。",
                    "type": "decimals",
                    "decimal": 2
                  },
                  {
                    "value": "alc",
                    "metric_key": "alc",
                    "enName": "Sessions per user",
                    "cnName": "平均登录次数",
                    "rainbowKey": "",
                    "explainEn": "Sessions per user.\nDaily: Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly: Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                    "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                    "type": "decimals",
                    "decimal": 2
                  },
                  {
                    "value": "retentionUsers",
                    "metric_key": "retention_users",
                    "enName": "DAU Retention Users",
                    "cnName": "日活留存",
                    "rainbowKey": "",
                    "explainEn": "The number of users who logged in during the recent 7 days(T-1~T-7) and have logged in to the game during the statistical period (deduplicated).",
                    "explainCn": "日活跃构成中的留存用户数，统计周期前一个周期 前7天(T-1~T-7) 登录了游戏并且在统计周期当期也有登录的用户数。",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "churnUsers",
                    "metric_key": "new_churn_users",
                    "enName": "Churn Users",
                    "cnName": "日流失",
                    "rainbowKey": "",
                    "explainEn": "Daily: The number of users who logged in yesterday but did not log in today.\nWeekly: The number of users who logged in last week but did not log in this week.\nMonthly: The number of users who logged in last month but did not log in this month.",
                    "explainCn": "日：昨天登录了并且在今天未登录的用户数\n周：上周登录了并且在本周未登录的用户数\n月：上个月登录了并且在本月未登录的用户数。",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "returnUsers",
                    "metric_key": "return_users",
                    "enName": "DAU Return Users",
                    "cnName": "日回流",
                    "rainbowKey": "",
                    "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                    "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存",
                    "type": "int",
                    "decimal": 0
                  },
                  {
                    "value": "wd237",
                    "metric_key": "weighted_d2",
                    "enName": "Weighted D1",
                    "cnName": "加权次留",
                    "rainbowKey": "",
                    "explainEn": "Day 1 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 1 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                    "explainCn": "加权次留=游戏上线之日起至统计日对（新注册用户数*新增次日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "weightedD3",
                    "metric_key": "weighted_d3",
                    "enName": "Weighted D2",
                    "cnName": "加权2留",
                    "rainbowKey": "",
                    "explainEn": "Day 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 2 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                    "explainCn": "加权2留=游戏上线之日起至统计日对（新注册用户数*新增2日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "weightedD7",
                    "metric_key": "weighted_d7",
                    "enName": "Weighted D6",
                    "cnName": "加权6留",
                    "rainbowKey": "",
                    "explainEn": "Day 6 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 6 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                    "explainCn": "加权6留=游戏上线之日起至统计日对（新注册用户数*新增6日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "weightedD14",
                    "metric_key": "weighted_d14",
                    "enName": "Weighted D13",
                    "cnName": "加权13留",
                    "rainbowKey": "",
                    "explainEn": "Day 13 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 13 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                    "explainCn": "加权13留=游戏上线之日起至统计日对（新注册用户数*新增13日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "firstLoginRatio",
                    "metric_key": "first_login_ratio",
                    "enName": "1st Order Login%",
                    "cnName": "一阶登录比",
                    "rainbowKey": "",
                    "explainEn": "1st Order Login%: 3-day valid registers / 2-day valid registers.\n2-day valid registers: the number of users who login for at least two days within seven days, starting from the day of registering.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering. Considered as the retention users of 2-day valid registers.",
                    "explainCn": "一阶登录比=3天有效注册用户数/2天有效注册用户数\n2天有效注册用户：从注册日开始计算，七天内至少有2天登录游戏的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数，认为是2天有效注册用户的留存用户；",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "secondLoginRatio",
                    "metric_key": "second_login_ratio",
                    "enName": "2nd Order Login%",
                    "cnName": "二阶登录比",
                    "rainbowKey": "",
                    "explainEn": "2nd Order Login%: 3-day valid retained users / 3-day valid registers.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering.\n3-day valid retained users: the number of 3-day valid registered users who login within the eighth day and the fourteenth day from the day of registering. Considered as the retention users of 3-day valid registers.",
                    "explainCn": "二阶登录比=3天有效注册留存用户数/3天有效注册用户数\n3天有效注册留存用户：3天有效注册用户数中，在8-14天有登录行为的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数",
                    "type": "percent",
                    "decimal": 2
                  }
                ]
              },
              "defaultInicator": "dau"
            }
          }
        }
      ],
      "filters": [
        {
          "name": "NightingaleDateComparisonFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": false,
          "filterPath": "/comparisonAnalysis/dateComparison/keyPerformance",
          "componentList": [
            {
              "name": "dateComparisonTrendService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/comparison_analysis/date/linechart",
                  "isDark": true
                }
              },
              "children": [
                {
                  "name": "DateComparisonMetricsTrend",
                  "style": {
                    "marginTop": "20px"
                  },
                  "props": {
                    "config": {
                      "subTitleCom": [
                        {
                          "titleEn": "Statistics Date",
                          "titleCn": "统计日期",
                          "subTitle1En": "Average",
                          "subTitle1Cn": "平均值 ",
                          "subTitle2En": "Sum ",
                          "subTitle2Cn": "汇总值",
                          "subTitle3En": "Max",
                          "subTitle3Cn": "最大值"
                        },
                        {
                          "titleEn": "Contrast Date",
                          "titleCn": "对比日期",
                          "subTitle1En": "Average",
                          "subTitle1Cn": "平均值",
                          "subTitle2En": "Sum ",
                          "subTitle2Cn": "汇总值",
                          "subTitle3En": "Max",
                          "subTitle3Cn": "最大值"
                        }
                      ]
                    }
                  }
                }
              ]
            },
            {
              "name": "ComparisonTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/comparison_analysis/date/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/comparison_analysis/date/overall_performance/download"
                  },
                  "dataKey": "date_comparison",
                  "tableKey": "key_performance",
                  "dateDisabled": true,
                  "componentMetrics": [
                    {
                      "Day": [
                        {
                          "metricKey": "active_users",
                          "reqMetricKey": "active_users",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 85,
                          "cnWidth": 85,
                          "enContrastWidth": 160,
                          "cnContrastWidth": 160,
                          "enName": "DAU",
                          "cnName": "日活跃",
                          "explainEn": "Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).",
                          "explainCn": "统计周期内登录过游戏的用户数(vopenid数去重)。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_users",
                          "reqMetricKey": "new_users",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 85,
                          "cnWidth": 85,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "New",
                          "cnName": "新进用户",
                          "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (userid deduplicated).",
                          "explainCn": "统计周期内新注册用户数(userid数去重)。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "total_users",
                          "reqMetricKey": "total_users",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 105,
                          "cnWidth": 125,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 155,
                          "enName": "TNU",
                          "cnName": "总注册用户数",
                          "explainEn": "Total New Users. Total number of registered users accumulated to the statistical day (vopenid deduplicated).",
                          "explainCn": "累计至统计日的注册用户总数(vopenid数去重)。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pay_amount",
                          "reqMetricKey": "pay_amount",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 190,
                          "enWidth": 115,
                          "cnWidth": 130,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Revenue($)",
                          "cnName": "付费金额($)",
                          "explainEn": "Total amounts, including net revenue of units and download content and gross revenue of microtransactions. Revenue= Units Rev + DLC Rev + In-Game Rev.",
                          "explainCn": "总收入金额，包括游戏本体售卖、DLC售卖的净收入及游戏内购收入的总金额。总收入= 总体拷贝收入 + DLC 收入 + 内购收入。",
                          "rainbowKey": "",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "pcu",
                          "reqMetricKey": "pcu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 77,
                          "cnWidth": 77,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "PCU",
                          "cnName": "最高同时在线",
                          "explainEn": "The highest number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "取当天各时刻（每5分钟打点）最高的同时在线用户数。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "acu",
                          "reqMetricKey": "acu",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 77,
                          "cnWidth": 77,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "ACU",
                          "cnName": "平均同时在线",
                          "explainEn": "The average number of users online simultaneously at each moment (every 5 minutes) of the day.",
                          "explainCn": "将当天内各时刻（每5分钟打点）的在线数进行平均统计。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "aot_hour",
                          "reqMetricKey": "aot_hour",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 164,
                          "cnWidth": 164,
                          "enContrastWidth": 240,
                          "cnContrastWidth": 240,
                          "enName": "Avg.Playtime(h)",
                          "cnName": "平均在线时长(小时)",
                          "explainEn": "",
                          "explainCn": "",
                          "rainbowKey": "Pc Avg.Playtime(h)",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d1",
                          "reqMetricKey": "d1",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 70,
                          "cnWidth": 70,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D1",
                          "cnName": "次留",
                          "explainEn": "The retention rate of new register users on day 1. Number of retained users on day N from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "次留=xx注册日期第1天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d2",
                          "reqMetricKey": "d2",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 70,
                          "cnWidth": 70,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D2",
                          "cnName": "2留",
                          "explainEn": "The retention rate of new register users on day 2. Registration date is day 0",
                          "explainCn": "2留=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d3",
                          "reqMetricKey": "d3",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 70,
                          "cnWidth": 70,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D3",
                          "cnName": "3留",
                          "explainEn": "The retention rate of new register users on day 3. Registration date is day 0",
                          "explainCn": "3留=xx注册日期第3天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d4",
                          "reqMetricKey": "d4",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 70,
                          "cnWidth": 70,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D4",
                          "cnName": "4留",
                          "explainEn": "The retention rate of new register users on day 4. Registration date is day 0",
                          "explainCn": "4留=xx注册日期第4天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d5",
                          "reqMetricKey": "d5",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 70,
                          "cnWidth": 70,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D5",
                          "cnName": "5留",
                          "explainEn": "The retention rate of new register users on day 5. Registration date is day 0",
                          "explainCn": "5留=xx注册日期第5天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d6",
                          "reqMetricKey": "d6",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 70,
                          "cnWidth": 70,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D6",
                          "cnName": "6留",
                          "explainEn": "The retention rate of new register users on day 6. Registration date is day 0",
                          "explainCn": "6留=xx注册日期第6天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "d7",
                          "reqMetricKey": "d7",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 70,
                          "cnWidth": 70,
                          "enContrastWidth": 140,
                          "cnContrastWidth": 140,
                          "enName": "D7",
                          "cnName": "7留",
                          "explainEn": "The retention rate of new register users on day 7. Registration date is day 0",
                          "explainCn": "7留=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "mtx_payers",
                          "reqMetricKey": "mtx_payers",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 190,
                          "enWidth": 150,
                          "cnWidth": 112,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 190,
                          "enName": "In-Game Payer",
                          "cnName": "内购付费人数",
                          "explainEn": "Total number of users who have in-game payment behaviors in the statistical period (deduplicated)",
                          "explainCn": "统计期间内有游戏内付费行为的用户总数（去重）",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_payer_rate",
                          "reqMetricKey": "mtx_payer_rate",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 190,
                          "enWidth": 165,
                          "cnWidth": 150,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 190,
                          "enName": "In-Game Payer%",
                          "cnName": "内购付费渗透率",
                          "explainEn": "Number of In-Game paying users/Number of active users during the statistical period",
                          "explainCn": "内购付费人数/统计周期内的活跃人数",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_arpu",
                          "reqMetricKey": "mtx_arpu",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 190,
                          "enWidth": 145,
                          "cnWidth": 112,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 190,
                          "enName": "In-Game ARPU",
                          "cnName": "内购ARPU",
                          "explainEn": "In-Game Revenue/Number of active users during the statistical period",
                          "explainCn": "内购收入/统计周期内的活跃人数",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "mtx_arppu",
                          "reqMetricKey": "mtx_arppu",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 190,
                          "enWidth": 155,
                          "cnWidth": 150,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 190,
                          "enName": "In-Game ARPPU",
                          "cnName": "内购付费ARPPU",
                          "explainEn": "In-Game Revenue/Number of In-Game pay users during the statistical period",
                          "explainCn": "内购收入/统计期间内的内购付费人数",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_paid_users",
                          "reqMetricKey": "new_paid_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 140,
                          "enWidth": 144,
                          "cnWidth": 144,
                          "enContrastWidth": 220,
                          "cnContrastWidth": 220,
                          "enName": "First-time Payer",
                          "cnName": "首次付费用户",
                          "explainEn": "The number of users who have payment behaviors for the first time in the statistical period.",
                          "explainCn": "在游戏内首次发生付费行为的玩家数。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_pay_amount",
                          "reqMetricKey": "new_pay_amount",
                          "enPercentWidth": 230,
                          "cnPercentWidth": 230,
                          "enWidth": 220,
                          "cnWidth": 220,
                          "enContrastWidth": 300,
                          "cnContrastWidth": 300,
                          "enName": "Revenue(first-time payer)",
                          "cnName": "首次付费用户金额",
                          "explainEn": "Amount actually paid by first-time payer in the statistical period.",
                          "explainCn": "统计周期内的首次付费用户产生的所有付费金额。",
                          "rainbowKey": "",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_arppu",
                          "reqMetricKey": "new_arppu",
                          "enPercentWidth": 230,
                          "cnPercentWidth": 230,
                          "enWidth": 240,
                          "cnWidth": 240,
                          "enContrastWidth": 310,
                          "cnContrastWidth": 310,
                          "enName": "First-time Payer ARPPU($)",
                          "cnName": "首次付费用户ARPPU($)",
                          "explainEn": "Consumption amount of first-time payer/Number of first-time payer during the statistical period.",
                          "explainCn": "首次付费用户ARPPU($)=统计周期内首次付费用户的消费额/首次付费用户数",
                          "rainbowKey": "",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "alc",
                          "reqMetricKey": "alc",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 125,
                          "enWidth": 160,
                          "cnWidth": 160,
                          "enContrastWidth": 230,
                          "cnContrastWidth": 230,
                          "enName": "Sessions per user",
                          "cnName": "平均登录次数",
                          "explainEn": "Daily：Sum of the number of times all users have entered the game on that day/Players logged in the game on the day.\nWeekly：Sum of the number of times all users have entered the game on that week/Players logged in the game on the week.\nMonthly: Sum of the number of times all users have entered the game on that month/Players logged in the game on the month.",
                          "explainCn": "日：平均登录次数=当日所有用户进入游戏次数总和/当日活跃用户\n周：平均登录次数=当周所有用户进入游戏次数总和/当周活跃用户\n月：平均登录次数=当月所有用户进入游戏次数总和/当月活跃用户",
                          "rainbowKey": "",
                          "type": "decimals",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "retention_users",
                          "reqMetricKey": "retention_users",
                          "enPercentWidth": 190,
                          "cnPercentWidth": 120,
                          "enWidth": 210,
                          "cnWidth": 210,
                          "enContrastWidth": 260,
                          "cnContrastWidth": 260,
                          "enName": "DAU Retention Users",
                          "cnName": "日活留存",
                          "explainEn": "The number of users who logged in during the recent 7 days(T-1~T-7) and have logged in to the game during the statistical period (deduplicated).",
                          "explainCn": "日活跃构成中的留存用户数，统计周期前一个周期 前7天(T-1~T-7) 登录了游戏并且在统计周期当期也有登录的用户数。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "new_churn_users",
                          "reqMetricKey": "new_churn_users",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 160,
                          "enWidth": 114,
                          "cnWidth": 114,
                          "enContrastWidth": 190,
                          "cnContrastWidth": 190,
                          "enName": "Churn Users",
                          "cnName": "日流失",
                          "explainEn": "The number of users who have not logged in for more than 7 consecutive days",
                          "explainCn": "连续超过7天未登录的用户数",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "return_users",
                          "reqMetricKey": "return_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 170,
                          "enWidth": 170,
                          "cnWidth": 170,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 250,
                          "enName": "DAU Return Users",
                          "cnName": "日回流",
                          "explainEn": "Daily Return = Daily Active - Daily Retained - Daily New.\nWeekly Return = Weekly Active - Weekly Retained - Weekly New.\nMonthly Return = Monthly Active - Monthly Retained - Monthly New.",
                          "explainCn": "日回流=日活跃-日新进-日留存\n周回流=周活跃-周新进-周留存\n月回流=月活跃-月新进-月留存。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d2",
                          "reqMetricKey": "weighted_d2",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 122,
                          "cnWidth": 80,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D1",
                          "cnName": "加权次留",
                          "explainEn": "Day 1 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 1 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权次留=游戏上线之日起至统计日对（新注册用户数*新增次日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 2
                        },
                        {
                          "metricKey": "weighted_d3",
                          "reqMetricKey": "weighted_d3",
                          "enPercentWidth": 120,
                          "cnPercentWidth": 145,
                          "enWidth": 122,
                          "cnWidth": 80,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D2",
                          "cnName": "加权2留",
                          "explainEn": "Day 2 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 2 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权2留=游戏上线之日起至统计日对（新注册用户数*新增2日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d7",
                          "reqMetricKey": "weighted_d7",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 122,
                          "cnWidth": 80,
                          "enContrastWidth": 200,
                          "cnContrastWidth": 200,
                          "enName": "Weighted D6",
                          "cnName": "加权6留",
                          "explainEn": "Day 6 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 6 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权6留=游戏上线之日起至统计日对（新注册用户数*新增6日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "weighted_d14",
                          "reqMetricKey": "weighted_d14",
                          "enPercentWidth": 145,
                          "cnPercentWidth": 145,
                          "enWidth": 132,
                          "cnWidth": 90,
                          "enContrastWidth": 210,
                          "cnContrastWidth": 210,
                          "enName": "Weighted D13",
                          "cnName": "加权13留",
                          "explainEn": "Day 13 weighted retention ratio, which refers to the sum of (number of newly-registered users * day 13 retention ratio) from the game launching day to the statistical day/the sum of the number of newly-registered users from the game launching day to the statistical day.",
                          "explainCn": "加权13留=游戏上线之日起至统计日对（新注册用户数*新增13日留存率）求和/游戏上线之日起至统计日新注册用户数之和。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "first_login_ratio",
                          "reqMetricKey": "first_login_ratio",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 145,
                          "enWidth": 160,
                          "cnWidth": 145,
                          "enContrastWidth": 236,
                          "cnContrastWidth": 236,
                          "enName": "1st Order Login%",
                          "cnName": "一阶登录比",
                          "explainEn": "1st Order Login%: 3-day valid registers / 2-day valid registers.\n2-day valid registers: the number of users who login for at least two days within seven days, starting from the day of registering.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering. Considered as the retention users of 2-day valid registers.",
                          "explainCn": "一阶登录比=3天有效注册用户数/2天有效注册用户数\n2天有效注册用户：从注册日开始计算，七天内至少有2天登录游戏的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数，认为是2天有效注册用户的留存用户；",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "second_login_ratio",
                          "reqMetricKey": "second_login_ratio",
                          "enPercentWidth": 160,
                          "cnPercentWidth": 145,
                          "enWidth": 160,
                          "cnWidth": 145,
                          "enContrastWidth": 250,
                          "cnContrastWidth": 250,
                          "enName": "2nd Order Login%",
                          "cnName": "二阶登录比",
                          "explainEn": "2nd Order Login%: 3-day valid retained users / 3-day valid registers.\n3-day valid registers: the number of users who login for at least three days within seven days, starting from the day of registering.\n3-day valid retained users: the number of 3-day valid registered users who login within the eighth day and the fourteenth day from the day of registering. Considered as the retention users of 3-day valid registers.",
                          "explainCn": "二阶登录比=3天有效注册留存用户数/3天有效注册用户数\n3天有效注册留存用户：3天有效注册用户数中，在8-14天有登录行为的用户数\n3天有效注册用户：从注册日开始计算，七天内至少有3天登录游戏的用户数",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        }
                      ]
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "retention",
      "tabName": "Retention Tracking Comparison",
      "tabNameCN": "留存追踪对比",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/dateComparison/retention",
      "path": "/comparisonAnalysis/dateComparison/retention",
      "tabIcon": "",
      "logConfig": {
        "pageId": "203602",
        "pageName": "nightingaleDateComparisonRetention",
        "extInfo": "nightingaleDateComparisonRetention",
        "pagePath": "/comparisonAnalysis/dateComparison/retention"
      },
      "data": {
        "dataFrame": "pc_inflextion",
        "metrics": {
          "value": "new",
          "metric_key": "new",
          "enName": "Return Rate",
          "cnName": "留存率",
          "rainbowKey": "",
          "explainEn": "",
          "explainCn": "",
          "type": "percent",
          "decimal": 2
        }
      },
      "children": [
        {
          "name": "SegmentMoreCo",
          "className": "",
          "style": {
            "marginTop": "0px"
          },
          "type": "view",
          "props": {
            "config": {
              "showExpand": false,
              "componentSegment": {
                "Day": [
                  {
                    "value": "new",
                    "metric_key": "new",
                    "enName": "Return Rate",
                    "cnName": "留存率",
                    "rainbowKey": "",
                    "explainEn": "",
                    "explainCn": "",
                    "type": "percent",
                    "decimal": 2
                  },
                  {
                    "value": "rolling_new",
                    "metric_key": "rolling_new",
                    "enName": "Rolling Retention",
                    "cnName": "滚动留存率",
                    "rainbowKey": "",
                    "explainEn": "",
                    "explainCn": "",
                    "type": "percent",
                    "decimal": 2
                  }
                ]
              },
              "defaultInicator": "new"
            }
          }
        }
      ],
      "filters": [
        {
          "data": {
            "dataFrame": "pc_inflextion"
          },
          "name": "NightingaleRetentionFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": false,
          "filterPath": "/comparisonAnalysis/dateComparison/retention",
          "componentList": [
            {
              "name": "dateComparisonTrendService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/comparison_analysis/date/retention/linechart",
                  "isDark": true,
                  "dataKey": "nightingaleRentation"
                }
              },
              "children": [
                {
                  "name": "RetentionChart",
                  "props": {
                    "config": {
                      "className": "register-table margin-t-20",
                      "defaultTab": 2,
                      "height": 340,
                      "bordered": false,
                      "dataKey": "metrics_list",
                      "apiKey": "nightingaleRentation",
                      "chart": {
                        "series": [
                          {
                            "key": "d1",
                            "name": "D1",
                            "nameCn": "次留"
                          },
                          {
                            "key": "d2",
                            "name": "D2",
                            "nameCn": "2留"
                          },
                          {
                            "key": "d3",
                            "name": "D3",
                            "nameCn": "3留"
                          },
                          {
                            "key": "d4",
                            "name": "D4",
                            "nameCn": "4留"
                          },
                          {
                            "key": "d5",
                            "name": "D5",
                            "nameCn": "5留"
                          },
                          {
                            "key": "d6",
                            "name": "D6",
                            "nameCn": "6留"
                          },
                          {
                            "key": "d7",
                            "name": "D7",
                            "nameCn": "7留"
                          },
                          {
                            "key": "d8",
                            "name": "D8",
                            "nameCn": "8留"
                          },
                          {
                            "key": "d9",
                            "name": "D9",
                            "nameCn": "9留"
                          },
                          {
                            "key": "d10",
                            "name": "D10",
                            "nameCn": "10留"
                          },
                          {
                            "key": "d11",
                            "name": "D11",
                            "nameCn": "11留"
                          },
                          {
                            "key": "d12",
                            "name": "D12",
                            "nameCn": "12留"
                          },
                          {
                            "key": "d13",
                            "name": "D13",
                            "nameCn": "13留"
                          },
                          {
                            "key": "d14",
                            "name": "D14",
                            "nameCn": "14留"
                          },
                          {
                            "key": "d15",
                            "name": "D15",
                            "nameCn": "15留"
                          },
                          {
                            "key": "d16",
                            "name": "D16",
                            "nameCn": "16留"
                          },
                          {
                            "key": "d17",
                            "name": "D17",
                            "nameCn": "17留"
                          },
                          {
                            "key": "d18",
                            "name": "D18",
                            "nameCn": "18留"
                          },
                          {
                            "key": "d19",
                            "name": "D19",
                            "nameCn": "19留"
                          },
                          {
                            "key": "d20",
                            "name": "D20",
                            "nameCn": "20留"
                          },
                          {
                            "key": "d21",
                            "name": "D21",
                            "nameCn": "21留"
                          },
                          {
                            "key": "d22",
                            "name": "D22",
                            "nameCn": "22留"
                          },
                          {
                            "key": "d23",
                            "name": "D23",
                            "nameCn": "23留"
                          },
                          {
                            "key": "d24",
                            "name": "D24",
                            "nameCn": "24留"
                          },
                          {
                            "key": "d25",
                            "name": "D25",
                            "nameCn": "25留"
                          },
                          {
                            "key": "d26",
                            "name": "D26",
                            "nameCn": "26留"
                          },
                          {
                            "key": "d27",
                            "name": "D27",
                            "nameCn": "27留"
                          },
                          {
                            "key": "d28",
                            "name": "D28",
                            "nameCn": "28留"
                          },
                          {
                            "key": "d29",
                            "name": "D29",
                            "nameCn": "29留"
                          },
                          {
                            "key": "d30",
                            "name": "D30",
                            "nameCn": "30留"
                          },
                          {
                            "key": "d31",
                            "name": "D31",
                            "nameCn": "31留"
                          },
                          {
                            "key": "d32",
                            "name": "D32",
                            "nameCn": "32留"
                          },
                          {
                            "key": "d33",
                            "name": "D33",
                            "nameCn": "33留"
                          },
                          {
                            "key": "d34",
                            "name": "D34",
                            "nameCn": "34留"
                          },
                          {
                            "key": "d35",
                            "name": "D35",
                            "nameCn": "35留"
                          },
                          {
                            "key": "d36",
                            "name": "D36",
                            "nameCn": "36留"
                          },
                          {
                            "key": "d37",
                            "name": "D37",
                            "nameCn": "37留"
                          },
                          {
                            "key": "d38",
                            "name": "D38",
                            "nameCn": "38留"
                          },
                          {
                            "key": "d39",
                            "name": "D39",
                            "nameCn": "39留"
                          },
                          {
                            "key": "d40",
                            "name": "D40",
                            "nameCn": "40留"
                          },
                          {
                            "key": "d41",
                            "name": "D41",
                            "nameCn": "41留"
                          },
                          {
                            "key": "d42",
                            "name": "D42",
                            "nameCn": "42留"
                          },
                          {
                            "key": "d43",
                            "name": "D43",
                            "nameCn": "43留"
                          },
                          {
                            "key": "d44",
                            "name": "D44",
                            "nameCn": "44留"
                          },
                          {
                            "key": "d45",
                            "name": "D45",
                            "nameCn": "45留"
                          },
                          {
                            "key": "d46",
                            "name": "D46",
                            "nameCn": "46留"
                          },
                          {
                            "key": "d47",
                            "name": "D47",
                            "nameCn": "47留"
                          },
                          {
                            "key": "d48",
                            "name": "D48",
                            "nameCn": "48留"
                          },
                          {
                            "key": "d49",
                            "name": "D49",
                            "nameCn": "49留"
                          },
                          {
                            "key": "d50",
                            "name": "D50",
                            "nameCn": "50留"
                          },
                          {
                            "key": "d51",
                            "name": "D51",
                            "nameCn": "51留"
                          },
                          {
                            "key": "d52",
                            "name": "D52",
                            "nameCn": "52留"
                          },
                          {
                            "key": "d53",
                            "name": "D53",
                            "nameCn": "53留"
                          },
                          {
                            "key": "d54",
                            "name": "D54",
                            "nameCn": "54留"
                          },
                          {
                            "key": "d55",
                            "name": "D55",
                            "nameCn": "55留"
                          },
                          {
                            "key": "d56",
                            "name": "D56",
                            "nameCn": "56留"
                          },
                          {
                            "key": "d57",
                            "name": "D57",
                            "nameCn": "57留"
                          },
                          {
                            "key": "d58",
                            "name": "D58",
                            "nameCn": "58留"
                          },
                          {
                            "key": "d59",
                            "name": "D59",
                            "nameCn": "59留"
                          },
                          {
                            "key": "d60",
                            "name": "D60",
                            "nameCn": "60留"
                          },
                          {
                            "key": "d61",
                            "name": "D61",
                            "nameCn": "61留"
                          },
                          {
                            "key": "d62",
                            "name": "D62",
                            "nameCn": "62留"
                          },
                          {
                            "key": "d63",
                            "name": "D63",
                            "nameCn": "63留"
                          },
                          {
                            "key": "d64",
                            "name": "D64",
                            "nameCn": "64留"
                          },
                          {
                            "key": "d65",
                            "name": "D65",
                            "nameCn": "65留"
                          },
                          {
                            "key": "d66",
                            "name": "D66",
                            "nameCn": "66留"
                          },
                          {
                            "key": "d67",
                            "name": "D67",
                            "nameCn": "67留"
                          },
                          {
                            "key": "d68",
                            "name": "D68",
                            "nameCn": "68留"
                          },
                          {
                            "key": "d69",
                            "name": "D69",
                            "nameCn": "69留"
                          },
                          {
                            "key": "d70",
                            "name": "D70",
                            "nameCn": "70留"
                          },
                          {
                            "key": "d71",
                            "name": "D71",
                            "nameCn": "71留"
                          },
                          {
                            "key": "d72",
                            "name": "D72",
                            "nameCn": "72留"
                          },
                          {
                            "key": "d73",
                            "name": "D73",
                            "nameCn": "73留"
                          },
                          {
                            "key": "d74",
                            "name": "D74",
                            "nameCn": "74留"
                          },
                          {
                            "key": "d75",
                            "name": "D75",
                            "nameCn": "75留"
                          },
                          {
                            "key": "d76",
                            "name": "D76",
                            "nameCn": "76留"
                          },
                          {
                            "key": "d77",
                            "name": "D77",
                            "nameCn": "77留"
                          },
                          {
                            "key": "d78",
                            "name": "D78",
                            "nameCn": "78留"
                          },
                          {
                            "key": "d79",
                            "name": "D79",
                            "nameCn": "79留"
                          },
                          {
                            "key": "d80",
                            "name": "D80",
                            "nameCn": "80留"
                          },
                          {
                            "key": "d81",
                            "name": "D81",
                            "nameCn": "81留"
                          },
                          {
                            "key": "d82",
                            "name": "D82",
                            "nameCn": "82留"
                          },
                          {
                            "key": "d83",
                            "name": "D83",
                            "nameCn": "83留"
                          },
                          {
                            "key": "d84",
                            "name": "D84",
                            "nameCn": "84留"
                          },
                          {
                            "key": "d85",
                            "name": "D85",
                            "nameCn": "85留"
                          },
                          {
                            "key": "d86",
                            "name": "D86",
                            "nameCn": "86留"
                          },
                          {
                            "key": "d87",
                            "name": "D87",
                            "nameCn": "87留"
                          },
                          {
                            "key": "d88",
                            "name": "D88",
                            "nameCn": "88留"
                          },
                          {
                            "key": "d89",
                            "name": "D89",
                            "nameCn": "89留"
                          },
                          {
                            "key": "d90",
                            "name": "D90",
                            "nameCn": "90留"
                          }
                        ],
                        "legend": [
                          {
                            "key": "{{statisticDate|string}}",
                            "name": "{{statisticDate|string}}",
                            "nameCn": "{{statisticDate|string}}"
                          },
                          {
                            "key": "{{contrastDate|string}}",
                            "name": "Contrast {{contrastDate|string}}",
                            "nameCn": "对比 {{contrastDate|string}}"
                          }
                        ]
                      }
                    }
                  }
                }
              ]
            },
            {
              "name": "ComparisonTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/comparison_analysis/date/retention/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/comparison_analysis/date/retention/overall_performance/download"
                  },
                  "dataKey": "date_comparison",
                  "tableKey": "retention",
                  "isHaveContrast": false,
                  "showStatistic": [
                    "avg"
                  ],
                  "dateDisabled": true,
                  "isShowSdlw": true,
                  "isShowDod": true,
                  "isShowChange": false,
                  "isShowMetricSetting": false,
                  "componentMetrics": [
                    {
                      "Day": [
                        {
                          "metricKey": "register_users",
                          "reqMetricKey": "register_users",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "New",
                          "cnName": "新进用户",
                          "explainEn": "New Register Users.Total number of newly-registered users in the statistical period (userid deduplicated).",
                          "explainCn": "统计周期内新注册用户数(userid数去重)。",
                          "rainbowKey": "",
                          "type": "int",
                          "decimal": 0,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d1",
                          "reqMetricKey": "d1",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D1",
                          "cnName": "次留",
                          "explainEn": "The retention rate of new register users on day 1. Number of retained users on day N from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.",
                          "explainCn": "次留=xx注册日期第1天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d2",
                          "reqMetricKey": "d2",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D2",
                          "cnName": "2留",
                          "explainEn": "The retention rate of new register users on day 2. Registration date is day 0",
                          "explainCn": "2留=xx注册日期第2天存留用户数/xx注册日期新注册用户数，注册日是第0天",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d3",
                          "reqMetricKey": "d3",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D3",
                          "cnName": "3留",
                          "explainEn": "The retention rate of new register users on day 3. Registration date is day 0.",
                          "explainCn": "3留=xx注册日期第3天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d4",
                          "reqMetricKey": "d4",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D4",
                          "cnName": "4留",
                          "explainEn": "The retention rate of new register users on day 4. Registration date is day 0.",
                          "explainCn": "4留=xx注册日期第4天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d5",
                          "reqMetricKey": "d5",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D5",
                          "cnName": "5留",
                          "explainEn": "The retention rate of new register users on day 5. Registration date is day 0.",
                          "explainCn": "5留=xx注册日期第5天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d6",
                          "reqMetricKey": "d6",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D6",
                          "cnName": "6留",
                          "explainEn": "The retention rate of new register users on day 6. Registration date is day 0.",
                          "explainCn": "6留=xx注册日期第6天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d7",
                          "reqMetricKey": "d7",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D7",
                          "cnName": "7留",
                          "explainEn": "The retention rate of new register users on day 7. Registration date is day 0.",
                          "explainCn": "7留=xx注册日期第7天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d8",
                          "reqMetricKey": "d8",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D8",
                          "cnName": "8留",
                          "explainEn": "The retention rate of new register users on day 8. Registration date is day 0.",
                          "explainCn": "8留=xx注册日期第8天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d9",
                          "reqMetricKey": "d9",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D9",
                          "cnName": "9留",
                          "explainEn": "The retention rate of new register users on day 9. Registration date is day 0.",
                          "explainCn": "9留=xx注册日期第9天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d10",
                          "reqMetricKey": "d10",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D10",
                          "cnName": "10留",
                          "explainEn": "The retention rate of new register users on day 10. Registration date is day 0.",
                          "explainCn": "10留=xx注册日期第10天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d11",
                          "reqMetricKey": "d11",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D11",
                          "cnName": "11留",
                          "explainEn": "The retention rate of new register users on day 11. Registration date is day 0.",
                          "explainCn": "11留=xx注册日期第11天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d12",
                          "reqMetricKey": "d12",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D12",
                          "cnName": "12留",
                          "explainEn": "The retention rate of new register users on day 12. Registration date is day 0.",
                          "explainCn": "12留=xx注册日期第12天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d13",
                          "reqMetricKey": "d13",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D13",
                          "cnName": "13留",
                          "explainEn": "The retention rate of new register users on day 13. Registration date is day 0.",
                          "explainCn": "13留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d14",
                          "reqMetricKey": "d14",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D14",
                          "cnName": "14留",
                          "explainEn": "The retention rate of new register users on day 14. Registration date is day 0.",
                          "explainCn": "14留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d15",
                          "reqMetricKey": "d15",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D15",
                          "cnName": "15留",
                          "explainEn": "The retention rate of new register users on day 15. Registration date is day 0.",
                          "explainCn": "15留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d16",
                          "reqMetricKey": "d16",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D16",
                          "cnName": "16留",
                          "explainEn": "The retention rate of new register users on day 16. Registration date is day 0.",
                          "explainCn": "16留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d17",
                          "reqMetricKey": "d17",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D17",
                          "cnName": "17留",
                          "explainEn": "The retention rate of new register users on day 17. Registration date is day 0.",
                          "explainCn": "17留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d18",
                          "reqMetricKey": "d18",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D18",
                          "cnName": "18留",
                          "explainEn": "The retention rate of new register users on day 18. Registration date is day 0.",
                          "explainCn": "18留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d19",
                          "reqMetricKey": "d19",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D19",
                          "cnName": "19留",
                          "explainEn": "The retention rate of new register users on day 19. Registration date is day 0.",
                          "explainCn": "19留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d20",
                          "reqMetricKey": "d20",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D20",
                          "cnName": "20留",
                          "explainEn": "The retention rate of new register users on day 20. Registration date is day 0.",
                          "explainCn": "20留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d21",
                          "reqMetricKey": "d21",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D21",
                          "cnName": "21留",
                          "explainEn": "The retention rate of new register users on day 21. Registration date is day 0.",
                          "explainCn": "21留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d22",
                          "reqMetricKey": "d22",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D22",
                          "cnName": "22留",
                          "explainEn": "The retention rate of new register users on day 22. Registration date is day 0.",
                          "explainCn": "22留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d23",
                          "reqMetricKey": "d23",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D23",
                          "cnName": "23留",
                          "explainEn": "The retention rate of new register users on day 23. Registration date is day 0.",
                          "explainCn": "23留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d24",
                          "reqMetricKey": "d24",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D24",
                          "cnName": "24留",
                          "explainEn": "The retention rate of new register users on day 24. Registration date is day 0.",
                          "explainCn": "24留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d25",
                          "reqMetricKey": "d25",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D25",
                          "cnName": "25留",
                          "explainEn": "The retention rate of new register users on day 25. Registration date is day 0.",
                          "explainCn": "25留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d26",
                          "reqMetricKey": "d26",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D26",
                          "cnName": "26留",
                          "explainEn": "The retention rate of new register users on day 26. Registration date is day 0.",
                          "explainCn": "26留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d27",
                          "reqMetricKey": "d27",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D27",
                          "cnName": "27留",
                          "explainEn": "The retention rate of new register users on day 27. Registration date is day 0.",
                          "explainCn": "27留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d28",
                          "reqMetricKey": "d28",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D28",
                          "cnName": "28留",
                          "explainEn": "The retention rate of new register users on day 28. Registration date is day 0.",
                          "explainCn": "28留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d29",
                          "reqMetricKey": "d29",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D29",
                          "cnName": "29留",
                          "explainEn": "The retention rate of new register users on day 29. Registration date is day 0.",
                          "explainCn": "29留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d30",
                          "reqMetricKey": "d30",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D30",
                          "cnName": "30留",
                          "explainEn": "The retention rate of new register users on day 30. Registration date is day 0.",
                          "explainCn": "30留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d31",
                          "reqMetricKey": "d31",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D31",
                          "cnName": "31留",
                          "explainEn": "The retention rate of new register users on day 31. Registration date is day 0.",
                          "explainCn": "31留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d32",
                          "reqMetricKey": "d32",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D32",
                          "cnName": "32留",
                          "explainEn": "The retention rate of new register users on day 32. Registration date is day 0.",
                          "explainCn": "32留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d33",
                          "reqMetricKey": "d33",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D33",
                          "cnName": "33留",
                          "explainEn": "The retention rate of new register users on day 33. Registration date is day 0.",
                          "explainCn": "33留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d34",
                          "reqMetricKey": "d34",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D34",
                          "cnName": "34留",
                          "explainEn": "The retention rate of new register users on day 34. Registration date is day 0.",
                          "explainCn": "34留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d35",
                          "reqMetricKey": "d35",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D35",
                          "cnName": "35留",
                          "explainEn": "The retention rate of new register users on day 35. Registration date is day 0.",
                          "explainCn": "35留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d36",
                          "reqMetricKey": "d36",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D36",
                          "cnName": "36留",
                          "explainEn": "The retention rate of new register users on day 36. Registration date is day 0.",
                          "explainCn": "36留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d37",
                          "reqMetricKey": "d37",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D37",
                          "cnName": "37留",
                          "explainEn": "The retention rate of new register users on day 37. Registration date is day 0.",
                          "explainCn": "37留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d38",
                          "reqMetricKey": "d38",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D38",
                          "cnName": "38留",
                          "explainEn": "The retention rate of new register users on day 38. Registration date is day 0.",
                          "explainCn": "38留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d39",
                          "reqMetricKey": "d39",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D39",
                          "cnName": "39留",
                          "explainEn": "The retention rate of new register users on day 39. Registration date is day 0.",
                          "explainCn": "39留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d40",
                          "reqMetricKey": "d40",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D40",
                          "cnName": "40留",
                          "explainEn": "The retention rate of new register users on day 40. Registration date is day 0.",
                          "explainCn": "40留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d41",
                          "reqMetricKey": "d41",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D41",
                          "cnName": "41留",
                          "explainEn": "The retention rate of new register users on day 41. Registration date is day 0.",
                          "explainCn": "41留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d42",
                          "reqMetricKey": "d42",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D42",
                          "cnName": "42留",
                          "explainEn": "The retention rate of new register users on day 42. Registration date is day 0.",
                          "explainCn": "42留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d43",
                          "reqMetricKey": "d43",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D43",
                          "cnName": "43留",
                          "explainEn": "The retention rate of new register users on day 43. Registration date is day 0.",
                          "explainCn": "43留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d44",
                          "reqMetricKey": "d44",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D44",
                          "cnName": "44留",
                          "explainEn": "The retention rate of new register users on day 44. Registration date is day 0.",
                          "explainCn": "44留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d45",
                          "reqMetricKey": "d45",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D45",
                          "cnName": "45留",
                          "explainEn": "The retention rate of new register users on day 45. Registration date is day 0.",
                          "explainCn": "45留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d46",
                          "reqMetricKey": "d46",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D46",
                          "cnName": "46留",
                          "explainEn": "The retention rate of new register users on day 46. Registration date is day 0.",
                          "explainCn": "46留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d47",
                          "reqMetricKey": "d47",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D47",
                          "cnName": "47留",
                          "explainEn": "The retention rate of new register users on day 47. Registration date is day 0.",
                          "explainCn": "47留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d48",
                          "reqMetricKey": "d48",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D48",
                          "cnName": "48留",
                          "explainEn": "The retention rate of new register users on day 48. Registration date is day 0.",
                          "explainCn": "48留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d49",
                          "reqMetricKey": "d49",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D49",
                          "cnName": "49留",
                          "explainEn": "The retention rate of new register users on day 49. Registration date is day 0.",
                          "explainCn": "49留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d50",
                          "reqMetricKey": "d50",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D50",
                          "cnName": "50留",
                          "explainEn": "The retention rate of new register users on day 50. Registration date is day 0.",
                          "explainCn": "50留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d51",
                          "reqMetricKey": "d51",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D51",
                          "cnName": "51留",
                          "explainEn": "The retention rate of new register users on day 51. Registration date is day 0.",
                          "explainCn": "51留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d52",
                          "reqMetricKey": "d52",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D52",
                          "cnName": "52留",
                          "explainEn": "The retention rate of new register users on day 52. Registration date is day 0.",
                          "explainCn": "52留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d53",
                          "reqMetricKey": "d53",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D53",
                          "cnName": "53留",
                          "explainEn": "The retention rate of new register users on day 53. Registration date is day 0.",
                          "explainCn": "53留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d54",
                          "reqMetricKey": "d54",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D54",
                          "cnName": "54留",
                          "explainEn": "The retention rate of new register users on day 54. Registration date is day 0.",
                          "explainCn": "54留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d55",
                          "reqMetricKey": "d55",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D55",
                          "cnName": "55留",
                          "explainEn": "The retention rate of new register users on day 55. Registration date is day 0.",
                          "explainCn": "55留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d56",
                          "reqMetricKey": "d56",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D56",
                          "cnName": "56留",
                          "explainEn": "The retention rate of new register users on day 56. Registration date is day 0.",
                          "explainCn": "56留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d57",
                          "reqMetricKey": "d57",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D57",
                          "cnName": "57留",
                          "explainEn": "The retention rate of new register users on day 57. Registration date is day 0.",
                          "explainCn": "57留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d58",
                          "reqMetricKey": "d58",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D58",
                          "cnName": "58留",
                          "explainEn": "The retention rate of new register users on day 58. Registration date is day 0.",
                          "explainCn": "58留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d59",
                          "reqMetricKey": "d59",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D59",
                          "cnName": "59留",
                          "explainEn": "The retention rate of new register users on day 59. Registration date is day 0.",
                          "explainCn": "59留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d60",
                          "reqMetricKey": "d60",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D60",
                          "cnName": "60留",
                          "explainEn": "The retention rate of new register users on day 60. Registration date is day 0.",
                          "explainCn": "60留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d61",
                          "reqMetricKey": "d61",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D61",
                          "cnName": "61留",
                          "explainEn": "The retention rate of new register users on day 61. Registration date is day 0.",
                          "explainCn": "61留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d62",
                          "reqMetricKey": "d62",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D62",
                          "cnName": "62留",
                          "explainEn": "The retention rate of new register users on day 62. Registration date is day 0.",
                          "explainCn": "62留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d63",
                          "reqMetricKey": "d63",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D63",
                          "cnName": "63留",
                          "explainEn": "The retention rate of new register users on day 63. Registration date is day 0.",
                          "explainCn": "63留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d64",
                          "reqMetricKey": "d64",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D64",
                          "cnName": "64留",
                          "explainEn": "The retention rate of new register users on day 64. Registration date is day 0.",
                          "explainCn": "64留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d65",
                          "reqMetricKey": "d65",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D65",
                          "cnName": "65留",
                          "explainEn": "The retention rate of new register users on day 65. Registration date is day 0.",
                          "explainCn": "65留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d66",
                          "reqMetricKey": "d66",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D66",
                          "cnName": "66留",
                          "explainEn": "The retention rate of new register users on day 66. Registration date is day 0.",
                          "explainCn": "66留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d67",
                          "reqMetricKey": "d67",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D67",
                          "cnName": "67留",
                          "explainEn": "The retention rate of new register users on day 67. Registration date is day 0.",
                          "explainCn": "67留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d68",
                          "reqMetricKey": "d68",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D68",
                          "cnName": "68留",
                          "explainEn": "The retention rate of new register users on day 68. Registration date is day 0.",
                          "explainCn": "68留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d69",
                          "reqMetricKey": "d69",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D69",
                          "cnName": "69留",
                          "explainEn": "The retention rate of new register users on day 69. Registration date is day 0.",
                          "explainCn": "69留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d70",
                          "reqMetricKey": "d70",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D70",
                          "cnName": "70留",
                          "explainEn": "The retention rate of new register users on day 70. Registration date is day 0.",
                          "explainCn": "70留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d71",
                          "reqMetricKey": "d71",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D71",
                          "cnName": "71留",
                          "explainEn": "The retention rate of new register users on day 71. Registration date is day 0.",
                          "explainCn": "71留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d72",
                          "reqMetricKey": "d72",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D72",
                          "cnName": "72留",
                          "explainEn": "The retention rate of new register users on day 72. Registration date is day 0.",
                          "explainCn": "72留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d73",
                          "reqMetricKey": "d73",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D73",
                          "cnName": "73留",
                          "explainEn": "The retention rate of new register users on day 73. Registration date is day 0.",
                          "explainCn": "73留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d74",
                          "reqMetricKey": "d74",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D74",
                          "cnName": "74留",
                          "explainEn": "The retention rate of new register users on day 74. Registration date is day 0.",
                          "explainCn": "74留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d75",
                          "reqMetricKey": "d75",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D75",
                          "cnName": "75留",
                          "explainEn": "The retention rate of new register users on day 75. Registration date is day 0.",
                          "explainCn": "75留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d76",
                          "reqMetricKey": "d76",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D76",
                          "cnName": "76留",
                          "explainEn": "The retention rate of new register users on day 76. Registration date is day 0.",
                          "explainCn": "76留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d77",
                          "reqMetricKey": "d77",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D77",
                          "cnName": "77留",
                          "explainEn": "The retention rate of new register users on day 77. Registration date is day 0.",
                          "explainCn": "77留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d78",
                          "reqMetricKey": "d78",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D78",
                          "cnName": "78留",
                          "explainEn": "The retention rate of new register users on day 78. Registration date is day 0.",
                          "explainCn": "78留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d79",
                          "reqMetricKey": "d79",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D79",
                          "cnName": "79留",
                          "explainEn": "The retention rate of new register users on day 79. Registration date is day 0.",
                          "explainCn": "79留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d80",
                          "reqMetricKey": "d80",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D80",
                          "cnName": "80留",
                          "explainEn": "The retention rate of new register users on day 80. Registration date is day 0.",
                          "explainCn": "80留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d81",
                          "reqMetricKey": "d81",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D81",
                          "cnName": "81留",
                          "explainEn": "The retention rate of new register users on day 81. Registration date is day 0.",
                          "explainCn": "81留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d82",
                          "reqMetricKey": "d82",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D82",
                          "cnName": "82留",
                          "explainEn": "The retention rate of new register users on day 82. Registration date is day 0.",
                          "explainCn": "82留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d83",
                          "reqMetricKey": "d83",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D83",
                          "cnName": "83留",
                          "explainEn": "The retention rate of new register users on day 83. Registration date is day 0.",
                          "explainCn": "83留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d84",
                          "reqMetricKey": "d84",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D84",
                          "cnName": "84留",
                          "explainEn": "The retention rate of new register users on day 84. Registration date is day 0.",
                          "explainCn": "84留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d85",
                          "reqMetricKey": "d85",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D85",
                          "cnName": "85留",
                          "explainEn": "The retention rate of new register users on day 85. Registration date is day 0.",
                          "explainCn": "85留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d86",
                          "reqMetricKey": "d86",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D86",
                          "cnName": "86留",
                          "explainEn": "The retention rate of new register users on day 86. Registration date is day 0.",
                          "explainCn": "86留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d87",
                          "reqMetricKey": "d87",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D87",
                          "cnName": "87留",
                          "explainEn": "The retention rate of new register users on day 87. Registration date is day 0.",
                          "explainCn": "87留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d88",
                          "reqMetricKey": "d88",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D88",
                          "cnName": "88留",
                          "explainEn": "The retention rate of new register users on day 88. Registration date is day 0.",
                          "explainCn": "88留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d89",
                          "reqMetricKey": "d89",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D89",
                          "cnName": "89留",
                          "explainEn": "The retention rate of new register users on day 89. Registration date is day 0.",
                          "explainCn": "89留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        },
                        {
                          "metricKey": "d90",
                          "reqMetricKey": "d90",
                          "enPercentWidth": 180,
                          "cnPercentWidth": 180,
                          "enWidth": 120,
                          "cnWidth": 120,
                          "enName": "D90",
                          "cnName": "90留",
                          "explainEn": "The retention rate of new register users on day 90. Registration date is day 0.",
                          "explainCn": "90留=xx注册日期第13天存留用户数/xx注册日期新注册用户数，注册日期是第0天。",
                          "rainbowKey": "",
                          "type": "percent",
                          "decimal": 2,
                          "percentDecimals": 1
                        }
                      ]
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};